export default __webpack_public_path__ + "static/media/speaker-gif.81ec38eb.webp";